var modules_3d0bf2ca = {"wrapper":"ContentWidget_module_wrapper__aae95007"};
import "../../../assets/esm/components/ContentWidget/src/ContentWidget~DsEsyB-U.css";

export { modules_3d0bf2ca as default };
//# sourceMappingURL=ContentWidget.module.less.js.map
